import type { FrontendWidget } from '../types';
import { CtaBlockComponent } from './CtaBlockComponent';
import { CtaBlockComponentB } from './CtaBlockComponentB';
import { CtaBlockComponentC } from './CtaBlockComponentC';
import type { CtaBlockConfig, CtaBlockResolved } from './types';

export const ctaBlockWidget: FrontendWidget<CtaBlockConfig, CtaBlockResolved> =
  {
    componentType: 'widgets.cta-block',
    displayName: 'CTA Block',
    ComponentA: CtaBlockComponent,
    ComponentB: CtaBlockComponentB,
    ComponentC: CtaBlockComponentC,
    resolveSync: (config) => config,
  };
